export const getAppSearchNames = `query GetAppSearchNames {
    getAppSearchNames {
              application  
            }
         } 
`;
